<template>
  <div class="rg-object-detail-list-wrapper" :style="cssVars">
    <component
      :is="scrollbarTag"
      class="rg-object-detail-list-scroll-bar"
      :key="$vs.rtl"
    >
      <div class="rg-object-detail-list">
        <rg-object-detail-item
          v-for="rgObject in rgObjectList"
          :key="rgObject.id"
          :objectId="rgObject.id"
          :rgObject="rgObject"
        ></rg-object-detail-item>
      </div>
    </component>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import RgObjectDetailItem from "./RgObjectDetailItem";

export default {
  name: "RgObjectDetailList",

  components: {
    VuePerfectScrollbar,
    RgObjectDetailItem,
  },

  props: {
    rgObjectList: {
      type: Array, // RgObject[]
      default: () => [],
    },
    hiddenBackground: {
      type: Boolean,
      default: true,
    },
    staticPosition: {
      type: Boolean,
      default: true,
    },
    clickNotClose: {
      type: Boolean,
      default: true,
    },
    sortDirection: {
      type: String, // "asc" | "desc"
      default: "desc", // 新しいものを上に表示する
    },
  },

  computed: {
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    cssVars() {
      const { sortDirection = "desc" } = this;
      const flexDirection =
        sortDirection === "asc" ? "column" : "column-reverse";
      return {
        "--rg-object-detail-list-flex-direction": flexDirection,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.rg-object-detail-list-wrapper {
  --rg-object-detail-list-flex-direction: column-reverse;
  --rg-object-detail-list-top: 77px;

  z-index: 1; // コンポーネントを地図上に表示し、コントローラーよりは奥に表示する
  position: absolute;
  top: var(--rg-object-detail-list-top);
  left: 9px;
  height: 100%; // スクロール可能にする
  max-height: calc(
    100% - var(--rg-object-detail-list-top)
  ); // column-reverseでも上から下に表示されるようにする
  overflow: hidden;

  background-color: transparent;
  pointer-events: none;

  .rg-object-detail-list-scroll-bar {
    height: fit-content;
    max-height: calc(
      100%
    ); // 普通に100%を指定すると、スクロールバーが表示されないためcalcを使っている

    pointer-events: auto;
  }

  .rg-object-detail-list {
    display: flex;
    flex-direction: var(--rg-object-detail-list-flex-direction);
    gap: 4px;
  }
}
</style>
